<template>
	<div class="container">
		<el-card>
			<div slot="header">商户销户</div>
			<div style="height: 100%">
				<el-button type="primary" @click="unbindMeter">解除绑定</el-button>
				<el-button type="primary" @click="cancelAccount">注销商户</el-button>
				<el-button type="primary" class="iconfont icon-excel" style="background-color: #1abc9c !important"
					@click="exportToExcel">
					导出excel</el-button>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<el-form-item label="创建时间" label-width="70px">
						<el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
						<label> 到 </label>
						<el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="商户编号">
						<el-input v-model="queryParams.code" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.name" placeholder="" clearable filterable class="searchTag">
							<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" style="width: 100%" height="92%" highlight-current-row
						id="cancelingTableInfo" @current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" align="center" width="160">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" width="150" align="center">
						</el-table-column>
						<el-table-column prop="code" label="商户编号" width="150" align="center">
						</el-table-column>
						<el-table-column prop="name" label="商户名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="detailAddress" label="联系地址"  align="center">
						</el-table-column>
						<el-table-column prop="electricBalance" label="电表账户余额(元)" width="150" align="center">
						</el-table-column>
						<el-table-column prop="waterBalance" label="水表账户余额(元)" width="150" align="center">
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" width="150" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<el-dialog title="解除绑定" :visible.sync="cancelAccountDialogVis" width="920px">
			<el-tabs v-model="activeName">
				<el-tab-pane label="电表销表" name="electric">
					<el-table :data="meterTableData" style="width: 100%" highlight-current-row
						@current-change="handleUnbindElectricRow">
						<el-table-column type="index" width="50" align="center" label="序号">
						</el-table-column>
						<el-table-column prop="meterAddr" label="电表编号" align="center">
						</el-table-column>
						<el-table-column prop="curDegree" label="当前电量(kW·h)" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.curDegree"
									oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
									@change="
                    electricCurDegreeChange(
                      scope.row.curDegree,
                      scope.row,
                      scope.$index
                    )
                  "></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="lastBillDegree" label="上一次结算电量(kW·h)" align="center" width="170">
						</el-table-column>
						<el-table-column prop="usages" label="当前用电量(kW·h)" align="center" width="145">
						</el-table-column>
						<el-table-column prop="price" label="价格(元)" align="center">
						</el-table-column>
						<el-table-column prop="money" label="当前应结(元)" align="center">
						</el-table-column>
					</el-table>
					<div style="margin-top: 10px">
						<el-form ref="form" :model="form" label-width="120px">
							<el-form-item label="电表账户余额(元)">
								<el-input v-model="unbindForm.meterBalance" disabled></el-input>
							</el-form-item>
							<el-form-item label="补/退金额(元)">
								<el-input v-model="unbindForm.meterDiff" disabled></el-input>
							</el-form-item>
						</el-form>
						<div style="text-align: right">
							<el-button type="primary" @click="unbindElectric">解绑电表</el-button>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="水表销表" name="water">
					<el-table :data="waterTableData" style="width: 100%" highlight-current-row
						@current-change="handleUnbindWaterRow">
						<el-table-column type="index" width="50" align="center" label="序号">
						</el-table-column>
						<el-table-column prop="meterAddr" label="水表编号" align="center">
						</el-table-column>
						<el-table-column prop="curDegree" label="当前水量(m³)" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.curDegree"
									oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
									@change="
                    waterCurDegreeChange(
                      scope.row.curDegree,
                      scope.row,
                      scope.$index
                    )
                  "></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="lastBillDegree" label="上一次结算水量(m³)" width="150" align="center">
						</el-table-column>
						<el-table-column prop="usages" label="当前用水量(m³)" align="center">
						</el-table-column>
						<el-table-column prop="price" label="价格(元)" align="center">
						</el-table-column>
						<el-table-column prop="money" label="当前应结(元)" align="center">
						</el-table-column>
					</el-table>
					<div style="margin-top: 10px">
						<el-form ref="form" :model="form" label-width="120px">
							<el-form-item label="水表账户余额(元)">
								<el-input v-model="unbindForm.waterBalance" disabled></el-input>
							</el-form-item>
							<el-form-item label="补/退金额(元)">
								<el-input v-model="unbindForm.waterDiff" disabled></el-input>
							</el-form-item>
						</el-form>
						<div style="text-align: right">
							<el-button type="primary" @click="unbindWater">解绑水表</el-button>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
	import {
		selectListLessee,
		selectListUnbind,
		unBindWater,
		unBindMeter,
		cancelAccount,
		selectListLesseeName,
	} from '../../api/merchant/cancelAccount';
	import {
		translateObjectEmptyAttributeToNull,
		NumberAdd,
		NumberSub,
		NumberMul,
	} from '../../untils/func';
	import exportTable from '../../untils/exportTable';
	export default {
		data() {
			return {
				form: {},
				cancelAccountDialogVis: false,
				activeName: 'electric',
				tableData: [],
				meterTableData: [],
				waterTableData: [],
				unbindForm: {},
				currentRow: null,
				currentRowE: null,
				currentRowW: null,
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
				},
				loading: false,
				total: 0,
				lesseeNameOptions: [],
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQuery();
				await this.getLesseeNameOption();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListLessee(param).then();
				this.tableData = response.data;
				this.total = response.total;
				this.loading = false;
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListLesseeName(param).then();
				this.lesseeNameOptions = response.data;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
			// 解除绑定电表/水表
			async unbindMeter() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await this.getSelectListUnbind();
					this.cancelAccountDialogVis = true;
				}
			},
			// 获取解除绑定对话框里 销户信息
			async getSelectListUnbind() {
				const res = await selectListUnbind({
					id: this.currentRow
				}).then();
				this.unbindForm = res.data;
				this.meterTableData = res.data.meterList;
				this.waterTableData = res.data.waterList;
			},
			// 解绑电表
			async unbindElectric() {
				if (this.currentRowE == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					let params = {
						id: this.currentRowE.id,
						endDegree: this.currentRowE.curDegree,
						endTime: this.currentRowE.curDataTime,
					};
					await unBindMeter(params).then();
					await this.getSelectListUnbind();
					this.cancelAccountDialogVis = false;
					await this.handleQuery();
					this.msgSuccess('解绑电表成功');
				}
			},
			// 解绑水表
			async unbindWater() {
				if (this.currentRowW == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					let params = {
						id: this.currentRowW.id,
						endDegree: this.currentRowW.curDegree,
						endTime: this.currentRowW.curDataTime,
					};
					await unBindWater(params).then();
					await this.getSelectListUnbind();
					this.cancelAccountDialogVis = false;
					await this.handleQuery();
					this.msgSuccess('解绑水表成功');
				}
			},
			// 销户
			async cancelAccount() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.$confirm('确定要删除吗?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(async () => {
						await cancelAccount({
							id: this.currentRow
						}).then();
						this.msgSuccess('注销成功');
						await this.handleQuery();
					});
				}
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				this.currentRow = val.id;
			},
			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('cancelingTableInfo', '商户信息');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			// 解除绑定 电表 选中当前行
			handleUnbindElectricRow(val) {
				this.currentRowE = val;
			},
			// 解除绑定 水表 选中当前行
			handleUnbindWaterRow(val) {
				this.currentRowW = val;
			},
			// 解除绑定对话框里  当前电量 change事件
			electricCurDegreeChange(degree, row, index) {
				if (degree < row.lastBillDegree) {
					this.$message.error('当前电量不能小于上一次结算电量');
				} else {
					this.meterTableData[index].usages = NumberSub(
						degree,
						row.lastBillDegree
					);
					this.meterTableData[index].money = NumberMul(
						this.meterTableData[index].usages,
						row.price
					).toFixed(2);
					var sum = 0;
					for (let i = 0; i < this.meterTableData.length; i++) {
						sum = NumberAdd(this.meterTableData[i].money, sum);
					}
					this.unbindForm.meterDiff = NumberSub(
						this.unbindForm.meterBalance,
						sum
					);
				}
			},
			// 解除绑定对话框里  当前水量 change事件
			waterCurDegreeChange(degree, row, index) {
				if (degree < row.lastBillDegree) {
					this.$message.error('当前水量不能小于上一次结算水量');
				} else {
					this.waterTableData[index].usages = NumberSub(
						degree,
						row.lastBillDegree
					);
					this.waterTableData[index].money = NumberMul(
						this.waterTableData[index].usages,
						row.price
					).toFixed(2);
					var sum = 0;
					for (let i = 0; i < this.waterTableData.length; i++) {
						sum = NumberAdd(this.waterTableData[i].money, sum);
					}
					this.unbindForm.waterDiff = NumberSub(
						this.unbindForm.waterBalance,
						sum
					);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	.searchForm {
		margin-top: 15px;

		/deep/ .el-form-item {
			margin-bottom: 10px;
		}
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	.searchTag {
		width: 200px;
	}

	.el-button {
		margin-left: 10px;
	}

	.tableStyle {
		height: calc(100% - 85px);
	}

	@media screen and (max-width: 1470px) {
		.tableStyle {
			height: calc(100% - 130px);
		}
	}
</style>
